import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchHolidayRequest } from "../../../api/holiday";
import moment from "moment";

class HolidaysDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                holidayDate: null,
                holidayType: null,
                area: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchHoliday(instanceId)
        }
    }

    fetchHoliday = (id) => {
        fetchHolidayRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            holidayDate,
            holidayType,
            area,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Holidays Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList('holidays')}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Holiday Date</p>
                            {holidayDate || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Holiday Type</p>
                            {holidayType || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Area</p>
                            {area && area.areaName ? area.areaName : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('holidays', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default HolidaysDetails;
